import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromTheme from '../reducers/theme.reducer';

export const getThemeState = createSelector(fromFeature.getThemeState, (state: fromTheme.ThemeState) => state);

export const getTheme = createSelector(getThemeState, (state: fromTheme.ThemeState) => state.theme);
export const getLogoUrl = createSelector(getThemeState, (state: fromTheme.ThemeState) => state.logoUrl);
export const getLightModeLogoUrl = createSelector(getThemeState, (state: fromTheme.ThemeState) => state.lightModeLogoUrl);

export const getThemeLogo = createSelector(getThemeState, (state: fromTheme.ThemeState) => {
  return {
    logoUrl: state.logoUrl,
    lightModeLogoUrl: state.lightModeLogoUrl,
  };
});
